module.exports = __webpack_public_path__ + "static/img/6-bg.81476a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/6-bg.png
// module id = 2lgM
// module chunks = 0